<script setup lang="ts">
const route = useRoute()
const appConfig = useAppConfig()
const { isHelpSlideoverOpen } = useDashboard()

const shareId = useState('shareId')

const activePatientDesign = useState('activePatientDesign', () => null)
const activePatientDesignList = useState('activePatientDesignList', () => [])
const activeLensDesignType = useState('activeLensDesignType', () => null)
const authUser = useState<any>('authUser')

const links = [{
  id: 'patient',
  label: '患者列表',
  icon: 'i-heroicons-user-group',
  to: '/patientDesign',
}]

const exportLoading = ref(false)

const innerMultiLinks = computed(() => {
  const list = [{
    id: 'export',
    label: '导出数据',
    icon: 'i-heroicons-cloud-arrow-down-20-solid',
    click: () => {
      console.log('侧边栏导出数据')
      exportLoading.value = true
      postApi('/craft/requestExportListExcel', {
        patientDesignIdList: activePatientDesignList.value,
      }).then((res) => {
        if(res.code === 0) {
          window.open(`/coreApi/craft/exportExcel?exportToken=${res.data?.exportToken}`, '_blank');
        } else {
          console.log(res.msg)
        }
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        setTimeout(() => {
          exportLoading.value = false
        }, 500)
      })
    },
    disabled: exportLoading.value,
  }]

  return list
})

const innerLinks = computed(() => {
	const list = [{
		id: 'param',
		label: '小艾订参',
		icon: 'i-heroicons-light-bulb',
    to: `/patientDesign/${activePatientDesign.value?.id}/param`,
		disabled: activePatientDesign.value === null || activePatientDesignList.value.length > 0
	}, {
		id: 'order',
		label: '参数信息',
		icon: 'i-heroicons-ticket',
    to: `/patientDesign/${activePatientDesign.value?.id}/order`,
		disabled: activePatientDesign.value === null || activePatientDesignList.value.length > 0
	}]

  if(activeLensDesignType.value === 'OD' && activePatientDesign.value?.patientEye?.eyeODStatus === 'HasMxfData') {
    list.unshift({
      id: 'design',
      label: 'CRAFT镜片设计',
      icon: 'i-heroicons-cpu-chip',
      to: `/patientDesign/${activePatientDesign.value?.id}/lensDesign/ChildOD`,
      disabled: activePatientDesign.value === null || activePatientDesignList.value.length > 0,
    })
  } else if(activeLensDesignType.value === 'OS' && activePatientDesign.value?.patientEye?.eyeOSStatus === 'HasMxfData') {
    list.unshift({
      id: 'design',
      label: 'CRAFT镜片设计',
      icon: 'i-heroicons-cpu-chip',
      to: `/patientDesign/${activePatientDesign.value?.id}/lensDesign/ChildOS`,
      disabled: activePatientDesign.value === null || activePatientDesignList.value.length > 0,
    })
  } else {
    if(activePatientDesign.value?.patientEye?.eyeODStatus === 'HasMxfData') {
      list.unshift({
        id: 'design',
        label: 'CRAFT镜片设计',
        icon: 'i-heroicons-cpu-chip',
        to: `/patientDesign/${activePatientDesign.value?.id}/lensDesign/ChildOD`,
        disabled: activePatientDesign.value === null || activePatientDesignList.value.length > 0,
      })
    } else if(activePatientDesign.value?.patientEye?.eyeOSStatus === 'HasMxfData') {
      list.unshift({
        id: 'design',
        label: 'CRAFT镜片设计',
        icon: 'i-heroicons-cpu-chip',
        to: `/patientDesign/${activePatientDesign.value?.id}/lensDesign/ChildOS`,
        disabled: activePatientDesign.value === null || activePatientDesignList.value.length > 0,
      })
    } else {
      list.unshift({
        id: 'design',
        label: 'CRAFT镜片设计',
        icon: 'i-heroicons-cpu-chip',
        to: `/patientDesign/${activePatientDesign.value?.id}/lensDesign`,
        disabled: activePatientDesign.value === null || activePatientDesignList.value.length > 0,
      })
    }
  }

  if(activePatientDesign.value) {
    list.unshift({
      id: 'patientItem',
      label: '患者信息',
      icon: 'i-heroicons-identification',
      to: `/patientDesign/${activePatientDesign.value?.id}/patient`,
      disabled: activePatientDesignList.value.length > 0
    })
  } else {
    list.unshift({
      id: 'patientItem',
      label: '患者信息',
      icon: 'i-heroicons-identification',
      to: `/patientDesign/null`,
      disabled: true
    })
  }

	return list
})

const footerLinks = [{
  label: 'Invite people',
  icon: 'i-heroicons-plus',
  to: '/settings/members'
}, {
  label: 'Help & Support',
  icon: 'i-heroicons-question-mark-circle',
  click: () => isHelpSlideoverOpen.value = true
}]
const groups = [{
  key: 'links',
  label: 'Go to',
  commands: links.map(link => ({ ...link, shortcuts: link.tooltip?.shortcuts }))
}]
const defaultColors = ref(['green', 'teal', 'cyan', 'sky', 'blue', 'indigo', 'violet'].map(color => ({ label: color, chip: color, click: () => appConfig.ui.primary = color })))
const colors = computed(() => defaultColors.value.map(color => ({ ...color, active: appConfig.ui.primary === color.label })))
const doAuthLogout = () => {
  authLogout()
}

const moreMenus = [{
	key: 'orderApiConfig',
	label: '下单接口',
	icon: 'i-heroicons-code-bracket-square',
	to: '/settings/orderApi'
}]

const managerMenus = computed(() => {
  const menus = [{
    key: 'managerUser',
    label: '用户管理',
    icon: 'i-heroicons-users',
    to: '/manager/user'
  }, {
    key: 'managerHospital',
    label: '医院管理',
    icon: 'i-heroicons-building-office-2',
    to: '/manager/hospital'
  }]

  if (['Administrator', 'HospitalAdmin'].includes(authUser.value?.roleName)) {
    menus.push({
      key: 'managerActivationCode',
      label: '激活码管理',
      icon: 'i-heroicons-key',
      to: '/manager/activation-code'
    })
  }

  return menus
})

const myUi = {
	wrapper: 'relative !min-h-[auto] !min-w-[auto]',
	container: '!overflow-visible',
	base: 'gap-2.5 px-2.5 py-2.5 my-1',
	active: 'text-gray-900 dark:text-white before:bg-gray-100 dark:before:bg-gray-800',
	inactive: 'text-gray-100 dark:text-gray-400 hover:text-gray-100 dark:hover:text-white hover:before:bg-primary-400 dark:hover:before:bg-gray-800/50',
	icon: {
		base: 'flex-shrink-0 w-5 h-5 relative',
		active: 'text-gray-900 dark:text-white',
		inactive: 'text-gray-100 dark:text-gray-500 group-hover:text-gray-100 dark:group-hover:text-gray-200'
	},
	trailingIcon: {
		base: 'ml-auto w-5 h-5 transform transition-transform duration-200 flex-shrink-0',
		active: '',
		inactive: '-rotate-90'
	},
	avatar: {
		base: 'flex-shrink-0',
		size: '2xs'
	},
	chip: {
		base: 'flex-shrink-0 mx-2.5',
		size: 'sm'
	},
	badge: {
		base: 'flex-shrink-0 ml-auto relative rounded',
		color: 'gray',
		variant: 'solid',
		size: 'xs'
	},
	label: 'text-sm truncate relative',
	dot: {
		wrapper: 'w-px h-full mx-[9.5px] bg-gray-200 dark:bg-gray-700 relative',
		after: 'after:absolute after:z-[1] after:w-px after:h-full after:bg-gray-200 after:dark:bg-gray-700 after:transform after:translate-y-full',
		base: 'w-1 h-1 rounded-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2',
		active: 'bg-gray-900 dark:bg-white',
		inactive: 'bg-gray-400 dark:bg-gray-500 group-hover:bg-gray-700 dark:group-hover:bg-gray-200'
	},
	tooltip: {
		strategy: 'override',
		transition: {
			enterActiveClass: 'transition ease-out duration-200',
			enterFromClass: 'opacity-0',
			enterToClass: 'opacity-100',
			leaveActiveClass: 'transition ease-in duration-150',
			leaveFromClass: 'opacity-100',
			leaveToClass: 'opacity-0'
		}
	},
	transition: {
		enterActiveClass: 'overflow-hidden transition-[height] duration-200 ease-out',
		leaveActiveClass: 'overflow-hidden transition-[height] duration-200 ease-out'
	}
}

const myUi2 = computed(() => {
	return {
		wrapper: 'relative !min-h-[auto] !min-w-[auto]',
		container: '!overflow-visible',
		base: 'gap-2 px-2 py-2 my-0.5 !flex-col !font-bold' + (activePatientDesign.value?'':'cursor-not-allowed'),
		active: 'text-gray-900 dark:text-white before:bg-gray-100 dark:before:bg-gray-800 !font-bold',
		inactive: 'text-gray-100 dark:text-gray-400 hover:text-gray-100 dark:hover:text-white hover:before:bg-primary-400 dark:hover:before:bg-gray-800/50 !font-bold',
		icon: {
			base: 'flex-shrink-0 w-5 h-5 relative',
			active: 'text-gray-900 dark:text-white',
			inactive: 'text-gray-100 dark:text-gray-500 group-hover:text-gray-100 dark:group-hover:text-gray-200'
		},
		trailingIcon: {
			base: 'ml-auto w-5 h-5 transform transition-transform duration-200 flex-shrink-0',
			active: '',
			inactive: '-rotate-90'
		},
		avatar: {
			base: 'flex-shrink-0',
			size: '2xs'
		},
		chip: {
			base: 'flex-shrink-0 mx-2.5',
			size: 'sm'
		},
		badge: {
			base: 'flex-shrink-0 ml-auto relative rounded',
			color: 'gray',
			variant: 'solid',
			size: 'xs'
		},
		label: 'text-[0.9rem] truncate relative',
		dot: {
			wrapper: 'w-px h-full mx-[9.5px] bg-gray-200 dark:bg-gray-700 relative',
			after: 'after:absolute after:z-[1] after:w-px after:h-full after:bg-gray-200 after:dark:bg-gray-700 after:transform after:translate-y-full',
			base: 'w-1 h-1 rounded-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2',
			active: 'bg-gray-900 dark:bg-white',
			inactive: 'bg-gray-400 dark:bg-gray-500 group-hover:bg-gray-700 dark:group-hover:bg-gray-200'
		},
		tooltip: {
			strategy: 'override',
			transition: {
				enterActiveClass: 'transition ease-out duration-200',
				enterFromClass: 'opacity-0',
				enterToClass: 'opacity-100',
				leaveActiveClass: 'transition ease-in duration-150',
				leaveFromClass: 'opacity-100',
				leaveToClass: 'opacity-0'
			}
		},
		transition: {
			enterActiveClass: 'overflow-hidden transition-[height] duration-200 ease-out',
			leaveActiveClass: 'overflow-hidden transition-[height] duration-200 ease-out'
		}
	}
})

const sidebarUi = {
  wrapper: 'flex flex-col w-full flex-1 relative overflow-hidden',
  container: 'flex-grow flex flex-col min-h-0 gap-y-2 py-2',
  header: 'w-full flex flex-col px-2',
  body: 'flex-1 px-2 flex flex-col gap-y-2 overflow-y-auto',
  footer: 'flex items-center justify-between gap-x-1.5 flex-shrink-0 px-2'
}
</script>
<template>
  <UDashboardLayout>
    <UDashboardPanel :width="140" :resizable="{ min: 140, max: 140 }"  collapsible class="bg-primary">
      <UDashboardNavbar class="!border-transparent" :ui="{ wrapper: 'px-2', left: 'flex-1' }">
        <template #left>
          <div class="flex-1 flex-shrink-0 w-full py-2 px-2 rounded-md bg-white/80">
            <img src="../public/图片1.png" alt="" class="w-full h-full object-contain">
          </div>
        </template>
      </UDashboardNavbar>

      <UDashboardSidebar
        :ui="sidebarUi"
      >

        <UDashboardSidebarLinks
            :links="links"
            :ui="myUi2"
            class="select-none"
            style="color: black"
        >

        </UDashboardSidebarLinks>

        <UDivider />

        <div
            v-if="activePatientDesignList.length > 0"
            class="flex flex-col gap-0 text-gray-200 text-sm selection:bg-gray-600"
        >
          <div class="flex justify-between items-center gap-2 p-2 rounded hover:bg-[rgba(255,255,255,0.1)]">
            <div class="shrink-0">
              <div>
                已选择
              </div>
            </div>
            <div class="ml-2 font-bold">
              {{ activePatientDesignList.length }} 条
            </div>
          </div>
        </div>

	      <UDashboardSidebarLinks
          v-if="activePatientDesignList.length === 0"
		      :links="innerLinks"
		      :ui="myUi2"
		      class="select-none"
	      >
	      </UDashboardSidebarLinks>

        <UDashboardSidebarLinks
            v-if="activePatientDesignList.length > 0"
            :links="innerMultiLinks"
            :ui="myUi2"
            class="select-none"
        >

        </UDashboardSidebarLinks>


        <UDivider v-if="false && activePatientDesign" />

        <div
            v-if="activePatientDesignList.length === 0 && activePatientDesign && activePatientDesign?.lensOrder"
            class="flex flex-col gap-0 text-gray-200 text-sm selection:bg-gray-600"
        >
          <div class="flex justify-between items-center gap-2 p-2 rounded hover:bg-[rgba(255,255,255,0.1)]">
            <div class="shrink-0">
              <div v-if="activePatientDesign?.lensOrder?.OD">
	              OD
              </div>
	            <div v-if="activePatientDesign?.lensOrder?.OS">
		            OS
	            </div>
            </div>
            <div class="ml-2 font-bold">
              已确认
            </div>
          </div>
        </div>

	      <UDashboardSidebarLinks v-if="false" :links="[{ label: 'Colors', draggable: true, children: colors }]" @update:links="colors => defaultColors = colors" />

        <div class="flex-1" />

        <UDashboardSidebarLinks v-if="false" :links="footerLinks" />

<!--        <UDivider class="sticky bottom-0" />-->

        <template #footer>
	        <div class="w-full flex flex-col gap-2">
            <div v-if="['Administrator', 'HospitalAdmin', 'RegionAdmin'].includes(authUser?.roleName)">
              <UDashboardSidebarLinks
                  :links="[{ label: '管理菜单', children: managerMenus, defaultOpen: true }]"
                  :ui="myUi"
                  class="select-none"
              />
            </div>
		        <div>
			        <UDashboardSidebarLinks
				        :links="[{ label: '高级选项', children: moreMenus, defaultOpen: false }]"
				        :ui="myUi"
				        class="select-none"
			        />
		        </div>
		        <div>
              <!-- ~/components/UserDropdown.vue -->
              <UserDropdown />
		        </div>
	        </div>
        </template>
      </UDashboardSidebar>
    </UDashboardPanel>

    <nuxt-page :keepalive="{max: 4}" />

    <!-- ~/components/HelpSlideover.vue -->
    <HelpSlideover />
    <!-- ~/components/NotificationsSlideover.vue -->
    <NotificationsSlideover />

    <ClientOnly>
      <LazyUDashboardSearch :groups="groups" />
    </ClientOnly>
  </UDashboardLayout>
</template>

<style scoped>

</style>
